import { Fragment, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FileEarmarkPlus, Headset, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { getCustomerServiceList } from "../../store/api/ServiceAPI";
import { useHistory } from "react-router-dom";
import BihamtaTable from "../../../Components/BihamtaTable";
import ModalHappyCall from "../../../Components/Modals/ModalHappyCall";
const CustomerServiceList = (props) => {
    const { searchData, customer } = useSelector(state => {
        return {
            searchData: state.service.customerServiceFilters,
            customer: state.customerDataReducer.currentCustomer
        }
    });

    const { customerID } = props;
    const history = useHistory();
    //const searchData = useRef({});
    const dateFrom = useRef();
    const dateTo = useRef();
    const dispatch = useDispatch();
    const [modalHappyCall, setModalHappyCall] = useState({ show: false });
    const search = () => {
        searchData.Skip = 0;
        searchData.CustommerId = customerID;
        searchData.Take = 10;
        if (dateFrom.current.input.value === "") {
            searchData.DateFrom = null;
        }
        if (dateTo.current.input.value === "") {
            searchData.DateTo = null;
        }
        dispatch(getCustomerServiceList(searchData));
    }
    const showService = (serviceType, serviceID) => {
        window.open(`/Services/Service/${serviceID}/${serviceType}`);
    }
    function showModalHappyCall(row) {
        setModalHappyCall({
            show: true,
            ProductID: row.ProductID,
            ServiceType: row.ServiceType,
            ServiceID: row.ID,
            ProductName: row.ProductName,
            ProductModel: row.ProductModel,
            InvoiceNumber: row.InvoiceNumber,
            PServiceType: row.PServiceType,
            ProductSerial: row.ProductSerial,
            CustomerPhone: customer.Phone,
            CustomerMobile: customer.Mobile,
            CustomerName: customer.Name,
            ContactDate: row.PContactDate,
            SendDeliveryDate: row.PSendDeliverDate
        })
    }
    const tableColes = [
        { colTitle: "تاریخ پذیرش", colName: "PContactDate", showInMobile: true },
        { colTitle: "نوع خدمت", colName: "PServiceType", showInMobile: true },
        { colTitle: "شماره سرویس ", colName: "InvoiceNumber", showInMobile: true },
        { colTitle: "نام محصول", colName: "ProductName", showInMobile: false },
        { colTitle: "مدل محصول", colName: "ProductModel", showInMobile: false },
        { colTitle: "سریال محصول", colName: "ProductSerial" },
        { colTitle: "آغاز گارانتی", colName: "PGuaranteeStartDate" },
        { colTitle: "پایان گارانتی", colName: "PGuaranteeEndDate" },
        { colTitle: "مانده گارانتی", colName: "RemainedGuarantee", styleCondition: (row) => row.Color === "red" ? { color: "#ff4900" } : { color: "#3eb212" } },
        { colTitle: "ایاب و ذهاب", colName: "TransportationCost", showInMobile: false, colType: "currency" },
        { colTitle: "هزینه قطعات", colName: "UsedPartsCost", showInMobile: false, colType: "currency" },
        { colTitle: "سایر خدمات", colName: "ExtraServiceCost", showInMobile: false, colType: "currency" },
        { colTitle: "مجموع اجرتها", colName: "ServiceCost", showInMobile: false, colType: "currency" },
        { colTitle: "مبلغ کل سرویس", colName: "AmountCustomerShouldPay", showInMobile: false, colType: "currency" },
        { colTitle: "تخفیف", colName: "Discount", showInMobile: false, colType: "currency" },
        { colTitle: "مبلغ دریافتی", colName: "CustomerPayment", showInMobile: false, colType: "currency" }

    ]
    const tableRowButtons = [
        { type: "common", icon: <Headset size={19} color="#0ea053" className="rowBtn" />, tooltip: "رضایت سنجی", text: "رضایت سنجی", onclick: showModalHappyCall },
        {
            title: "نمایش سرویس", type: "show", className: "group-Btn-smalll", onclick: (item) => showService(item.ServiceType, item.ID)
        }

    ]
    return (
        <Fragment>
            <ModalHappyCall popData={modalHappyCall} setPopData={setModalHappyCall} />
            <div className="row">
                <div className="form-group col-md-2">
                    <label>نوع خدمت</label>
                    <select className="form-control" onChange={e => searchData.ServiceType = e.target.value}>
                        <option value="">انتخاب کنید</option>
                        <option value={1}>نصب</option>
                        <option value={2}>تعمیر</option>
                    </select>
                </div>
                <div className="col-md-2 form-group">
                    <label>تاریخ پذیرش از</label>
                    <DatePicker ref={dateFrom} isGregorian={false} timePicker={false} className="form-control"
                        onChange={value => { searchData.DateFrom = value.local("en").format("YYYY/MM/DD") }} />
                </div>
                <div className="col-md-2 form-group">
                    <label>تاریخ پذیرش تا</label>
                    <DatePicker ref={dateTo} isGregorian={false} timePicker={false} className="form-control"
                        onChange={value => { searchData.DateTo = value.local("en").format("YYYY/MM/DD") }} />
                </div>
                <div className="col-md-3 form-group">
                    <Button className="group-Btn" style={{ marginTop: "23px" }} onClick={search}><Search size={18} />&nbsp;جستجوی سرویس</Button>
                    &nbsp;&nbsp;
                    <Button variant="secondary" href={`/CRM/AddEditCustomerService/0/0/${customerID}`} className="group-Btn" style={{ marginTop: "23px" }}><FileEarmarkPlus size={18} />&nbsp;پذیرش جدید</Button>
                </div>
            </div>
            <BihamtaTable filterData={searchData} searchMethod={(data) => dispatch(getCustomerServiceList(data))} columns={tableColes}
                rowButtons={tableRowButtons} reducerName="service" objectName="customerServiceList" hasPaging style={{ whiteSpace: "nowrap" }} />
        </Fragment >
    )
}
export default CustomerServiceList;